import { LocallyAugmentedExample } from '@/types/LocallyAugmentedExample';
import ExampleSimpleRow from './ExampleSimpleRow';

interface CheatListProps {
  cheats: LocallyAugmentedExample[];
  showActions?: boolean;
  showDifficulty?: boolean;
  clickable?: boolean;
}

const CheatList = (props: CheatListProps) => {
  const { cheats } = props;

  if (!cheats) {
    return null;
  }

  const renderedCheats = cheats.map((cheat) => (
    <ExampleSimpleRow
      key={cheat.example}
      showShortDescription
      example={cheat}
    />
  ));

  return <div className="grid gap-4 py-4">{renderedCheats}</div>;
};

export default CheatList;
